'use client';

import { Button, Icon, Logo } from '../../components';
import { Paper } from '../../layout';

export interface MagicLinkSentProps {
  title: React.ReactNode;
  /** Message to show (e.g., "We sent a sign-in link…") */
  message: React.ReactNode;
  /** The email address the link was sent to */
  email?: string;
  /** Secondary text (e.g., "The link expires in 15 minutes") */
  expiryNotice?: string;
  /** Resend link button label */
  resendButtonTitle?: string;
  onResend?: () => void;
  resendDisabled?: boolean;
  /** Optional CAPTCHA widget rendered above the resend button */
  captcha?: React.ReactNode;
  /** "Use a different email" button label */
  changeEmailButtonTitle?: string;
  /** href for "use a different email" — navigates back to sign-in */
  changeEmailHref?: string;
}

export function MagicLinkSent(props: MagicLinkSentProps) {
  const {
    title,
    message,
    email,
    expiryNotice,
    resendButtonTitle,
    onResend,
    resendDisabled = false,
    captcha,
    changeEmailButtonTitle,
    changeEmailHref
  } = props;

  return (
    <div className='flex flex-col items-center gap-xl w-full max-w-md px-md sm:px-0'>
      <Logo className='h-10'></Logo>
      <Paper className='flex flex-col items-center gap-sm shadow-lg border border-border-base rounded-xl w-full p-lg sm:p-xl'>
        <div className='flex items-center justify-center w-12 h-12 rounded-full bg-success-solid mb-sm'>
          <Icon
            name='check'
            className='text-white text-xl stroke-current [stroke-width:32] [stroke-linejoin:round] [stroke-linecap:round]'
          />
        </div>
        <h2 className='text-xl font-bold text-foreground'>{title}</h2>
        <Paper.Content className='w-full flex flex-col items-center gap-md'>
          <p className='text-foreground-muted text-center text-sm'>{message}</p>

          {email && <p className='text-foreground font-medium text-center text-sm'>{email}</p>}

          {expiryNotice && (
            <p className='text-foreground-muted text-center text-xs italic'>{expiryNotice}</p>
          )}

          {captcha}

          {resendButtonTitle && onResend && (
            <Button
              variant='primary'
              size='full'
              className='w-full! mt-md'
              onClick={onResend}
              disabled={resendDisabled}
            >
              {resendButtonTitle}
            </Button>
          )}

          {changeEmailButtonTitle && changeEmailHref && (
            <a href={changeEmailHref} className='w-full'>
              <Button variant='default' size='full' className='w-full!'>
                {changeEmailButtonTitle}
              </Button>
            </a>
          )}
        </Paper.Content>
      </Paper>
    </div>
  );
}
